import i18n from 'i18next'
import languageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { web } from '@migratory/locales'

const { home: resources } = web

const detection = {
  lookupLocalStorage: 'accept-language',
  caches: ['localStorage'],
}

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    ns: ['translations-web'],
    defaultNS: 'translations-web',
    lng: localStorage.getItem('accept-language') || 'es-CR',
    detection,
    fallbackLng: 'es-CR',
    resources,
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler(lng, ns, key) {
      if (process.env.NODE_ENV === 'development') {
        console.log(
          `%c 🚨 Hacen falta esta key en el archivo ${ns} 🚨 `,
          'color: red'
        )
        console.log(`%c Key: ${key}`, 'color: yellow')
      }
    },
    interpolation: {
      escapeValue: false,
      prefix: '{{',
      suffix: '}}',
    },
  })

export default i18n
